import {openResourceModal} from '../../core/modalCommand';
import {
	PORT_RANGE_CREATE_MODAL_EVENT,
	PORT_RANGE_DELETE_MODAL_EVENT,
} from './events';

/**
 * Open Add Port Range.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openPortRangeCreateModal(command, envelope) {
	return openResourceModal(PORT_RANGE_CREATE_MODAL_EVENT, command, envelope);
}

/**
 * Open Delete Port Range.
 *
 * The confirmation, not the deletion. Nothing is removed until
 * the person presses the button inside it.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openPortRangeDeleteModal(command, envelope) {
	return openResourceModal(PORT_RANGE_DELETE_MODAL_EVENT, command, envelope);
}
